import React, { Component } from 'react'
import Slider from "react-slick";
import { connect } from "react-redux";
import { getUserData } from "../../store/ducks/currentUser/actions";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";
// import { Icon } from '@iconify/react';
import { isDesktop } from "react-device-detect";
import SideBar from '../../components/SideBar/SideBar';

const video = [
  { id: 1, video: "sponsor-video-one.mp4" },
  // { id: 2, video: "123final.mp4" },
  // { id: 3, video: "123final.mp4" },
  // { id: 4, video: "123final.mp4" },
]

const actorDetails = [
  { id: 1, name: "name-1", dob: "dob-1", ocp: "ocp-1", portfolio: "port-1", prize: "prize-1", image: "big_head_-1.webp", mobileimg: "small_head_-1.webp", icons: "abstract01.webp" },
  { id: 2, name: "name-2", dob: "dob-2", ocp: "ocp-2", portfolio: "port-2", prize: "prize-2", image: "big_head_-2.webp", mobileimg: "small_head_-1.webp", icons: "abstract02.webp" },
  { id: 3, name: "name-3", dob: "dob-3", ocp: "ocp-3", portfolio: "port-3", prize: "prize-3", image: "big_head_-3.webp", mobileimg: "small_head_-1.webp", icons: "abstract03.webp" },
  { id: 4, name: "name-5", dob: "dob-5", ocp: "ocp-5", portfolio: "port-5", prize: "prize-5", image: "big_head_-5.webp", mobileimg: "small_head_-1.webp", icons: "abstract05.webp" },
  { id: 5, name: "name-6", dob: "dob-6", ocp: "ocp-6", portfolio: "port-6", prize: "prize-6", image: "big_head_-6.webp", mobileimg: "small_head_-1.webp", icons: "abstract06.webp" },
  { id: 6, name: "name-7", dob: "dob-7", ocp: "ocp-7", portfolio: "port-7", prize: "prize-7", image: "big_head_-7.webp", mobileimg: "small_head_-1.webp", icons: "abstract07.webp" },
  { id: 7, name: "name-10", dob: "dob-10", ocp: "ocp-10", portfolio: "port-10", prize: "prize-10", image: "big_head_-10.webp", mobileimg: "small_head_-1.webp", icons: "abstract010.webp" },
]

export class Sponsor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: video,
      actorDetails: actorDetails,
      nav1: null,
      nav2: null,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const img = this.imageImport(require.context("../../assets/images/sponsor/", false, /\.(png|jpe?g|svg|mp4|webp)$/));

    const settings = {
      slidesToShow: 1,
      adaptiveHeight: false,
      centerMode: true,
      centerPadding: "180px",
      // infinite: true,
      dots: true,
      arrows: false,
    };

    const settings2 = {
      slidesToShow: 1,
      adaptiveHeight: false,
      centerMode: true,
      centerPadding: "140px",
      // infinite: true,
      dots: true,
      arrows: false,
    };

    const actorDetails = {
      centerMode: true,
      adaptiveHeight: false,
      centerPadding: "0",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    };

    const actorThumb = {
      className: "slider-two",
      centerMode: (!isDesktop) ? false : true,
      adaptiveHeight: false,
      centerPadding: "0",
      slidesToShow: (!isDesktop) ? 5 : 7,
      slidesToScroll: 1,
      arrows: false,
      dots: (!isDesktop) ? false : true,
      infinite: (!isDesktop) ? false : true,
      focusOnSelect: true,
    };

    let imageLanguage = '';
    switch (this.props.currentUser.language_code) {
      case "zh-CN":
        imageLanguage = "-cn"
        break;
      case "ms":
        imageLanguage = "-ms"
        break;
      case "id":
        imageLanguage = "-id"
        break;
      default:
        imageLanguage = ""
        break;
    }

    return (
      <Auxiliary>
        {
          isDesktop ? (

            <section className="sponsor">
              <div className="banner-col">
                <div className="banner-item">
                  <img src={img[`sponsor-banner${imageLanguage}.webp`]}  alt="X33 sponsorship"/>
                </div>
              </div>
              <div className="x-container">
                <div className="body-one">
                  <img src={img[`sponsor-bg-1${imageLanguage}.webp`]} className="spnsor-bg-one"  alt="X33 sponsorship artwork"/>
                  <div className='sponsor-one-content'>
                    <div className="spnsor-slick">
                      <div className="slick-container">
                        <Slider ref={(c) => (this.slider = c)} {...settings}>
                          {this.state.video && this.state.video.map((item, index) => (
                            <div className="video-cont" key={index} >
                              <video className="w-100 h-auto" controls>
                                <source src={img[`${item.video}`]} type="video/mp4" />
                              </video>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                    <h4>{t("sponsor.subtitle-1")}</h4>
                  </div>
                </div>

                <div className="body-two">
                  <img src={img[`sponsor-bg-2${imageLanguage}.webp`]} className="spnsor-bg-two"  alt="X33 sponsorship artwork"/>
                  <div className='sponsor-two-content'>
                    <div className="spnsor-slick">
                      <div className="slick-container">
                        <Slider
                          asNavFor={this.state.nav2}
                          ref={(c) => (this.slider1 = c)}
                          {...actorDetails}
                        >
                          {this.state.actorDetails && this.state.actorDetails.map((item, index) => (
                            <div className="actor-cont" key={index} >
                              <div className="row d-flex justify-content-center">
                                <div className="col-8">
                                  <p><label>{t("sponsor.name")}</label>{t(`sponsor.${item.name}`)}</p>
                                  <p><label>{t("sponsor.dob")}</label>{t(`sponsor.${item.dob}`)}</p>
                                  <p><label>{t("sponsor.ocp")}</label>{t(`sponsor.${item.ocp}`)}</p>
                                  <p><label>{t("sponsor.port")}</label>{t(`sponsor.${item.portfolio}`)}</p>
                                  <label>{t("sponsor.prize")}</label><p>{t(`sponsor.${item.prize}`)}</p>
                                </div>
                                <div className="col-4">
                                  <img src={img[`${item.image}`]} alt="hong kong actor" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </Slider>
                        <Slider
                          asNavFor={this.state.nav1}
                          ref={(c) => (this.slider2 = c)}
                          {...actorThumb}
                        >
                          {this.state.actorDetails && this.state.actorDetails.map((item, index) => (
                            <div key={index} type="button">
                              <span className="center"><img src={img[`${item.icons}`]} alt="hong kong actor" />
                                <p>{t(`sponsor.${item.name}`)}</p></span>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section className="sponsor mobile-view">
              <SideBar />
              <div className="banner-col">
                <div className="banner-item">
                  <img src={img[`sponsor-banner${imageLanguage}-m.webp`]}  alt="X33 sponsorship"/>
                </div>
              </div>
              <div className="body-one mx-3 mb-3">
                <img src={img[`sponsor-bg-1${imageLanguage}.webp`]} className="spnsor-bg-one"  alt="X33 sponsorship artwork"/>
                <div className='sponsor-one-content'>
                  <div className="spnsor-slick">
                    <div className="slick-container">
                      <Slider ref={(c) => (this.slider = c)} {...settings2}>
                        {this.state.video && this.state.video.map((item, index) => (
                          <div className="video-cont" key={index} >
                            <video className="w-100 h-auto" controls>
                              <source src={img[`${item.video}`]} type="video/mp4" />
                            </video>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                  <p>{t("sponsor.subtitle-1")}</p>
                </div>
              </div>
              <div className="body-two mx-3">
                <img src={img[`sponsor-bg-m-2${imageLanguage}.webp`]} className="spnsor-bg-two"  alt="X33 sponsorship artwork"/>
                <div className='sponsor-two-content'>
                  <div className="spnsor-slick">
                    <div className="slick-container">
                      <Slider
                        asNavFor={this.state.nav2}
                        ref={(c) => (this.slider1 = c)}
                        {...actorDetails}
                      >
                        {this.state.actorDetails && this.state.actorDetails.map((item, index) => (
                          <div className="actor-cont" key={index} >
                            <div className="row d-flex justify-content-center g-2 ">
                              <div className="col-5">
                                <img src={img[`${item.image}`]} alt="hong kong actor" />
                              </div>
                              <div className="col-7">
                                <div className='d-flex justify-content-between'>
                                  <p><label>{t("sponsor.name")}</label>{t(`sponsor.${item.name}`)}</p>
                                  <p><label>{t("sponsor.dob")}</label>{t(`sponsor.${item.dob}`)}</p>
                                </div>

                                <p><label>{t("sponsor.ocp")}</label>{t(`sponsor.${item.ocp}`)}</p>
                                <p><label>{t("sponsor.port")}</label>{t(`sponsor.${item.portfolio}`)}</p>
                                <label>{t("sponsor.prize")}</label><p>{t(`sponsor.${item.prize}`)}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                      <Slider
                        asNavFor={this.state.nav1}
                        ref={(c) => (this.slider2 = c)}
                        {...actorThumb}
                      >
                        {this.state.actorDetails && this.state.actorDetails.map((item, index) => (
                          <div key={index} type="button">
                            <span className="center"><img src={img[`${item.icons}`]} alt="hong kong actor" />
                              <p>{t(`sponsor.${item.name}`)}</p></span>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )
        }
      </Auxiliary>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
  };
};
const mapDispatchToProps = {
  getUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Sponsor));